<template>
  <div class="panel">
    <div>
      <el-row>
        <h1 class="info-title">Convenient Powerful API</h1>
        <div class="info-content">
          <div>Developers can add middlewares, Tigo provides lots of convenient powerful API which developers can use to build a web service.</div>
          <div>Of course, Tigo framework contains some develop tool packages such as binding, logger and request. The binding package provides</div>
          <div>some functions to verify json/form's value. The request package provides some functions to make http request.</div>
        </div>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="info-content doc-demo">
            <h3 class="doc-title">Documentation And Demo</h3>
            <div>It's easy to use Tigo if you have used Tornado web framework.</div>
            <div>Tigo provides two kinds of url route type, you can read in right.</div>
            <br/>
            <h3 class="doc-title">Download Files</h3>
            <div>Firstly, you can <a href="https://karldoenitz.github.io/TigoOld/statics/documentation_en.pdf" class="link" target="_blank">click here</a>to download API documentation.</div>
            <div>Secondly, you can <a href="https://karldoenitz.github.io/TigoOld/source/Demos.zip" class="link" target="_blank">click here</a>to download some samples.</div>
            <h3 class="doc-title">Tool</h3>
            <div>The tool tiger is developed for Tigo framwork, developers can</div>
            <div>use this tool to create a Tigo projection, <a href="https://github.com/karldoenitz/tiger" class="link" target="_blank">click here</a> see more.</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="demo">
            <el-carousel :autoplay=false height="520px">
              <el-carousel-item >
                <img src="../../assets/demo.png" class="demo-pic"/>
              </el-carousel-item>
              <el-carousel-item >
                <img src="../../assets/demo1.png" class="demo-pic"/>
              </el-carousel-item>
              <el-carousel-item >
                <img src="../../assets/demo2.png" class="demo-pic"/>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DocumentationDemo",
  }
</script>

<style scoped>
  .panel {
    padding-top: 20px;
    height: 800px;
    width: 100%;
    background-color: #f2f2f3;
    font-family: "Avenir", serif;
  }

  .info-title {
    margin-top: 20px;
    font-family: "Avenir", serif;
  }

  .doc-title {
    margin-right: 100px;
  }

  .info-content {
    color: #797e8e;
    font-family: "Avenir", serif;
  }

  .doc-demo {
    margin: 50px 50px 10px 25%;
    overflow: hidden;
    width: 450px;
    height: auto;
    float: right;
  }

  .link {
    text-decoration: none;
  }

  .demo {
    margin: 50px 25% 10px 50px;
    overflow: hidden;
    width: 399px;
    float: left;
  }

  .demo-pic {
    width: 399px;
    height: 520px;
  }

  .el-carousel {
    height: 520px;
  }

  @media screen and (max-width: 913px) {

    .demo {
      display: none;
    }

    .doc-demo {
      display: none;
    }

    .panel {
      padding-top: 20px;
      width: 100%;
      height: auto;
      background-color: #f2f2f3;
      font-family: "Avenir", serif;
      padding-bottom: 20px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/en/DocumentationDemo.vue